<template>
  <div class="faq" style="display: flex;flex-direction: column;align-items: center;margin-bottom: 70px;">
    <div style="margin-top: 2.25rem;font-size: 3rem;line-height: 3.75rem;font-weight: bold;color: #B62D2E;">{{ $t('other.help') }}</div>
    <div style="display: flex;margin-top:0.5rem;">
        <span style="width: 1rem;height: 1rem;background:#B62D2E;border-radius: 50%;margin:0 0.5rem;"></span>
        <span style="width: 1rem;height: 1rem;background:#DE5934;border-radius: 50%;margin:0 0.5rem;"></span>
        <span style="width: 1rem;height: 1rem;background:#F1AA55;border-radius: 50%;margin:0 0.5rem;"></span>
    </div>
    <div class="faq-content">
      <div v-if="list.length>0">
          <el-divider></el-divider>
          <div v-for="(item,index) in list" :key="index">
            <div class="faqItem-box">
              <img style="width: 3rem;height: 3rem;margin-right:2rem" src="@/assets/images/math-symbol1.png" />
              <div class="faqItem-title">
                <span>{{item.title}}</span>
                <div v-if="isShow[index]" class="faqItem-content" v-html="item.answer">
               </div>
              </div>
              <div style="margin-left:2rem">
                <i v-if="!isShow[index]" class="el-icon-plus cursor-pointer" style="border:1px solid;border-radius:50%;" @click="onIcon(index)"></i>
                <i v-else class="el-icon-minus cursor-pointer" style="border:1px solid;border-radius:50%;" @click="onIcon(index)"></i>
              </div>
            </div>
            <el-divider></el-divider>
          </div>
      </div>
      <div v-else style="text-align:center;">
        <el-divider></el-divider>
        No Data
        <el-divider></el-divider>
      </div>
    </div>
  </div>
</template>

<script>
import {getFaqs} from '@/api/setting';
export default {
  data() {
      return {
         list:[],
         isShow: [],
      }
  },
  created(){
    this.getFaqs()
  },
  mounted () {

  },
  watch: {
    "$store.getters.language": {
      handler() {
        this.getFaqs()
      },
      deep: true,
    },
  },
  methods:{
    getFaqs() {
      this.isShow= [],
      getFaqs({lang:this.$store.getters.language=='en'?1:0,type:1}).then((v) => {
        this.list=v.data
        this.list.forEach(()=>{
          this.isShow.push(false)
        })
      })
    },
    onIcon(index) {
      this.isShow[index] = !this.isShow[index];
      this.$forceUpdate()
    },
  }
};
</script>

<style lang="scss" scoped>
.faq {
  padding:0 14vw;
}
.faq-content {
  margin-top: 1.875rem;
  min-width: 72vw;
}
.faqItem-box {
  margin: 2.5rem 0;
  display: flex;
  justify-content: space-between;
}
.faqItem-title {
  display: flex;
  flex-direction: column;
  flex:1;
  font-size: 1.5rem;
  font-weight: bold;
  color: #43403c;
}
.faqItem-content {
  margin-top: 1.5rem;
  font-weight: 400;
  font-size: 18px;
  line-height: 1.6; /* 行高更易读 */
  /* 1. 图片自适应（防止超宽） */
  img {
    max-width: 100%;
    height: auto;
    border-radius: 4px;
    margin: 10px 0;
  }

  /* 2. 段落/列表间距优化 */
  p, ul, ol {
    margin: 12px 0;
    line-height: 1.8;
  }

  /* 3. 标题样式统一 */
  h1, h2, h3 {
    margin: 20px 0 10px;
    color: #1f2937;
  }

  /* 4. 链接样式 */
  a {
    color: #3b82f6;
    text-decoration: underline;
  }
  a:hover {
    color: #2563eb;
  }

  /* 5. 防止横向溢出 */
  overflow-x: hidden;
}
@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
  .faq{
    padding:0 1.25rem 2rem;
  }
  .pictureCard-content{
    padding-bottom: 5.55rem;
  }
}
</style>